<template>
    <!--<v-container>-->
        <v-card class="elevation-0">
            <v-card-title class="justify-center"><H4 class="font-weight-bold">各房型分配數</H4></v-card-title>
            <!--<v-card-text>-->
                <apexchart :options="chartOptions" :series="series" height="280"></apexchart>
            <!--</v-card-text>-->
        </v-card>
    <!--</v-container>-->
</template>

<script>
export default {
    name : "CircleCharge",
    props: {
        house: {}
    },
    data : function () {

        const houseCount  = Object.values(JSON.parse(this.house.QT_HFORM));
        const houseLabels = Object.keys(JSON.parse(this.house.QT_HFORM));

        return {
            series      : houseCount,
            chartOptions: {
                labels     : houseLabels,
                colors     : ["#ffce51", "#3ea2b8", "#82be3a"],
                chart      : {
                    type: "donut"
                },
                legend     : {
                    show    : true,
                    fontSize: '16px',
                    position: 'bottom',
                },
                dataLabels : {
                    enabled: false
                },
                plotOptions: {
                    // donut: {
                    //     labels: {
                    //         show : true,
                    //         name : {
                    //             show      : true,
                    //             label     : "",
                    //             offsetY   : 10,
                    //             fontWeight: 800,
                    //             fontSize  : "22px",
                    //             fontFamily: "Helvetica, Arial, sans-serif",
                    //             color     : "#373d3f",
                    //             // formatter : function (val) {
                    //             //     return val;
                    //             // }
                    //         },
                    //         value: {
                    //             show      : false,
                    //             label     : "Total22222",
                    //             fontSize  : "16px",
                    //             fontFamily: "Helvetica, Arial, sans-serif",
                    //             fontWeight: 400,
                    //             color     : undefined,
                    //             offsetY   : 100
                    //             // formatter : function (val) {
                    //             //     return val;
                    //             // }
                    //         },
                    //         total: {
                    //             show      : true,
                    //             showAlways: true,
                    //             label     : "共" + Object.values(JSON.parse(this.house.QT_HFORM)).reduce((a, b) => a + b, 0) + "戶",
                    //             fontWeight: 800,
                    //             fontSize  : "16px",
                    //             fontFamily: "Helvetica, Arial, sans-serif",
                    //             color     : "#373d3f"
                    //             // formatter : function (w) {
                    //             //     return w.globals.houseTotal.reduce((a, b) => {
                    //             //         return a + b;
                    //             //     }, 0);
                    //             // }
                    //         }
                    //     }
                    // },
                    pie: {
                        customScale  : 1.05,
                        expandOnClick: false,
                        donut        : {
                            labels: {
                                show : true,
                                name : {
                                    show      : true,
                                    fontSize  : "22px",
                                    fontFamily: "Helvetica, Arial, sans-serif",
                                    fontWeight: 600,
                                    color     : undefined,
                                    offsetY   : 10,
                                    formatter : function (val) {
                                        return val;
                                    }
                                },
                                value: {
                                    show      : false,
                                    fontSize  : "16px",
                                    fontFamily: "Helvetica, Arial, sans-serif",
                                    fontWeight: 400,
                                    color     : undefined,
                                    offsetY   : 16,
                                    formatter : function (val) {
                                        return val;
                                    }
                                },
                                total: {
                                    show      : true,
                                    showAlways: true,
                                    label     : "共 " + Object.values(JSON.parse(this.house.QT_HFORM)).reduce((a, b) => a + b, 0) + " 戶",
                                    fontSize  : "18px",
                                    fontFamily: "Helvetica, Arial, sans-serif",
                                    fontWeight: 600,
                                    color     : "#373d3f",
                                    // formatter : function (w) {
                                    //     return w.globals.seriesTotals.reduce((a, b) => {
                                    //         return a + b;
                                    //     }, 0);
                                    // }
                                }
                            }
                        },
                    }
                },
                noData     : {
                    text         : "目前尚無資料",
                    align        : 'center',
                    verticalAlign: 'middle',
                    offsetX      : 0,
                    offsetY      : 0,
                    style        : {
                        color     : undefined,
                        fontSize  : '16px',
                        fontFamily: undefined
                    }
                }
            }
        };
    },
    // data : () => ({}),
    created() {},
    components: {},
    computed  : {},
    methods   : {}
};
</script>
